import { useState, Fragment, useEffect } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { Typography } from "@mui/material";

//Helpers
import { copyToClipboard, isJson } from 'Core/data/Helpers';

//Redux
import {
    vidFleetVideoOpenModal,
    searchEntityRequest,
    rawDataTabGetData,
    showRawDataModal,
    clearRedux,
} from "Redux/actions";

//views
import Others from './views/others'
import VidFleet from './views/vidFleet'
import VidFleetVideoRaw from "Modules/devices/.components/vidFleetVideo";
import ShowRawData from "Modules/rawData/.components/showRawData";
import VideoPlayer from "Modules/rawData/.components/videoPlayer";

const RawDataTab = (props) => {
    const { companyId, deviceId, manufacturer, height, className, timezone, device } = props;

    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const VidFleetVideoRawOpenModal = useSelector(state => state.vidFleetVideoRedux.openModal);
    const videoPlayerOpenModal = useSelector(state => state.videoPlayerRedux.openModal);
    const loadingRawData = useSelector(state => state.rawDataTabRedux.loading);
    const data = useSelector(state => state.rawDataTabRedux.data);
    const events = useSelector(state => state.generalRedux.events);

    //Local States
    const [rawData, setRawData] = useState("");

    const showModal = (raw) => {
        setRawData(raw);
        dispatch(showRawDataModal())
    }

    const showMedia = (source) => {
        let data = {
            messages: messages, //For to access to language keys
            mode: "picture",
            thumbnailUrl: source?.url,
            id: source?.sn, //This could be a ESN or Clip Id
            autoplay: false, //If is true the video will be played automatically
            disabled: false
        }
        if (source?.url?.includes(".mp4")) {
            data.mode = "video";
            data.type = "playback";
            data.id = source.clipID;
        }
        dispatch(vidFleetVideoOpenModal(data))
    }

    const renderView = () => {
        let showView = -1;

        if (manufacturer?.toUpperCase() === "VidFleet".toUpperCase())
            showView = 2
        else
            showView = 1

        return (
            <Fragment>
                {
                    showView === 1 &&
                    <Others
                        legacyId={companyId}
                        messages={messages}
                        getData={(filters) => {
                            console.log("filters to get data others view:", filters)
                            dispatch(rawDataTabGetData(deviceId, "getEventData", filters));
                        }}
                        id={deviceId}
                        data={data?.items || []}
                        total={data?.total || 0}
                        conditions={data?.conditions}
                        loadingRawData={loadingRawData}
                        copyToClipboard={copyToClipboard}
                        height={height}
                        showModal={showModal}
                        commonClearRedux={clearRedux}
                        className={className}
                        companyId={companyId}
                        timezone={timezone}
                        valuesPerPage={[50, 100, 200, 300, 500]}
                        device={device}
                        manufacturer={manufacturer}
                    />
                }
                {
                    showView === 2 &&
                    <VidFleet
                        messages={messages}
                        getData={(filters) => {
                            console.log("filters to get data vidfleet view:", filters)
                            dispatch(rawDataTabGetData(deviceId, "vidfleet", filters));
                        }}
                        id={deviceId}
                        data={data?.items || []}
                        total={data?.total || 0}
                        conditions={data?.conditions}
                        copyToClipboard={copyToClipboard}
                        height={height}
                        showMedia={showMedia}
                        commonClearRedux={clearRedux}
                        loadingRawData={loadingRawData}
                        companyId={companyId}
                        className={className}
                        timezone={timezone}
                        valuesPerPage={[50, 100, 200, 300, 500]}
                        device={device}
                    />
                }
                {
                    showView === -1 &&
                    <div>
                        <h1>
                            <Typography gutterBottom component="div">
                                {messages['raw_data_tab_unavailable_view']}
                            </Typography>
                        </h1>
                    </div>
                }
            </Fragment>
        );
    }

    useEffect(() => {
        (!events || events.length === 0) && dispatch(searchEntityRequest({ key: "events" }));
    }, []);

    return (
        <Fragment>
            {
                renderView()
            }
            {/* rawData modal */}
            <ShowRawData rawData={isJson(rawData) ?  JSON.parse(rawData) : rawData} />
            {/* media Modal */}
            {
                VidFleetVideoRawOpenModal &&
                <VidFleetVideoRaw />
            }
            {/* video player modal */}
            {
                videoPlayerOpenModal &&
                <VideoPlayer />
            }
        </Fragment>
    )
}
export default RawDataTab;